import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const HeartTrailContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 2; /* Above other content */
`;

const TrailHeart = styled.div`
    color: #ff69b4;
    font-size: 1.2em;
    position: absolute;
    transform: translate(-50%, -50%);
    opacity: 0;
    animation: fadeOut 1s forwards;

    @keyframes fadeOut {
        to { opacity: 0; }
    }
`;

function HeartTrail() {
    const [trail, setTrail] = useState([]);

    useEffect(() => {
        const handleMouseMove = (event) => {
            setTrail(prevTrail => [...prevTrail, { x: event.clientX, y: event.clientY, id: Date.now() }]);
        };

        window.addEventListener('mousemove', handleMouseMove);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    useEffect(() => {
        const cleanupInterval = setInterval(() => {
            setTrail(prevTrail => prevTrail.slice(prevTrail.length - 10)); // Keep last 10 hearts
        }, 100);

        return () => clearInterval(cleanupInterval);
    }, []);

    return (
        <HeartTrailContainer>
            {trail.map(heart => (
                <TrailHeart key={heart.id} style={{ left: heart.x, top: heart.y }}>💖</TrailHeart>
            ))}
        </HeartTrailContainer>
    );
}

export default HeartTrail;